import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  standalone: false
})
export class NotFoundComponent {
  constructor(private router: Router) {}

   goToCustomers() {
    this.router.navigate(['/user/customers']);
  }
}